import script from "./ContactFormComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactFormComponent.vue?vue&type=script&setup=true&lang=js"

import "./ContactFormComponent.vue?vue&type=style&index=0&id=05deae50&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05deae50"]])

export default __exports__